import {
  alias, bool, number, params, string, shape, arrayOf
} from '@thd-nucleus/data-sources';

export const dataModel = {
  clientOnlyProduct: alias('product').params({ itemId: string().isRequired() }).shape({
    pricing: params({ storeId: string() }).shape({
      value: number({ float: true }),
    }),
    fulfillment: params({ storeId: string() }).shape({
      fulfillmentOptions: arrayOf(shape({
        type: string(),
        services: arrayOf(shape({
          type: string()
        }))
      }))
    }),
    subscription: shape({
      defaultfrequency: string(),
      discountPercentage: string(),
      subscriptionEnabled: bool()
    })
  })
};
